module.exports = __webpack_public_path__ + "static/media/gm.21b07ec6.svg";